import { memo } from 'react';
import Text from '../../Text/Text';
import Box from '../../Box/Box';

function Label({ label, hasUnread }: { label: string; hasUnread?: boolean }) {
  return (
    <Box
      variant="gradient"
      position="absolute"
      transform="translateY(-10px)"
      gradient="accentBackground"
      paddingHorizontal="space-200"
      paddingVertical="space-100"
      borderRadius="radius-600"
    >
      {hasUnread ? (
        <Box
          position="absolute"
          top="space-0"
          right="space-0"
          transform={'translateY(-5px)'}
          variant="gradient"
          width={12}
          height={12}
          borderRadius="radius-full"
          gradient="attentionBackground"
        ></Box>
      ) : null}
      <Text
        variant="body-s-semi"
        color="accentSurfacePrimary"
        textAlign="center"
      >
        {label}
      </Text>
    </Box>
  );
}
export default memo(Label);
